import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Box} from "../../../model/box";

@Component({
  selector: 'aw-create-box',
  templateUrl: './create-box-dialog.component.html',
  styleUrls: ['./create-box-dialog.component.scss']
})
export class CreateBoxDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Box,
    public dialogRef: MatDialogRef<CreateBoxDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


